var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "63px",
    viewBox: "0 0 135 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_empty_street_sfxm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-27",
    transform: "translate(-30.000000, -440.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(18.000000, 397.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_empty_street_sfxm",
    transform: "translate(0.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 118,
    y: 25.5360721,
    width: 4,
    height: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2F2F2",
    points: "125 36.4742259 115.05903 24.5360721 95.10472 24.7202096 83 36.6218368 83.2446178 36.7805288 83.1572059 36.7805288 83.1572059 61.5360721 124.973302 61.5360721 124.973302 36.7805288"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6E6E6",
    points: "115.239392 24.5360721 103 39.2438032 103 61.5360721 125 61.5360721 125 36.4458899"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 111,
    y: 49.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 111,
    y: 42.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 111,
    y: 49.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 111,
    y: 42.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 91,
    y: 48.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 91,
    y: 41.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 86,
    y: 25.5360721,
    width: 4,
    height: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2F2F2",
    points: "93 36.4742259 83.0590297 24.5360721 63.10472 24.7202096 51 36.6218368 51.2446178 36.7805288 51.1572059 36.7805288 51.1572059 61.5360721 92.9733021 61.5360721 92.9733021 36.7805288"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6E6E6",
    points: "82.2393924 24.5360721 70 39.2438032 70 61.5360721 92 61.5360721 92 36.4458899"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 79,
    y: 49.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 79,
    y: 42.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 79,
    y: 49.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 79,
    y: 42.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 59,
    y: 48.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 59,
    y: 41.5360721,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 52,
    y: 13.5360721,
    width: 5,
    height: 19
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F2F2F2",
    points: "60 28.3459177 46.7454077 12.5360721 20.1395354 12.7798512 4 28.5415647 4.32603346 28.751719 4.2096026 28.751719 4.2096026 61.5360721 59.9642999 61.5360721 59.9642999 28.751719"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6E6E6",
    points: "47.6901255 12.5360721 31 32.0139361 31 61.5360721 61 61.5360721 61 28.308609"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 43,
    y: 45.5360721,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 43,
    y: 36.5360721,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 43,
    y: 45.5360721,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 43,
    y: 36.5360721,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 16,
    y: 44.5360721,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 16,
    y: 34.5360721,
    width: 6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 0,
    y: 61.4008172,
    width: 130,
    height: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 21,
    cy: 48.5360721,
    rx: 4,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6965355,61.5360721 C19.1372038,52.0660301 20.6808359,42.630202 20.6966104,42.5360721 L20.9999251,42.5880776 C20.9842255,42.6817511 19.449456,52.0680047 21,61.4849754 L20.6965355,61.5360721 Z",
    id: "Path",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#6C63FF",
    transform: "translate(22.302997, 48.035741) rotate(-28.141600) translate(-22.302997, -48.035741) ",
    points: "20.2847132 47.8801167 24.3212669 47.8803097 24.3212818 48.1913662 20.2847281 48.1911732"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#6C63FF",
    transform: "translate(18.546085, 48.989870) rotate(-61.842040) translate(-18.546085, -48.989870) ",
    points: "18.3904603 46.9715166 18.7015168 46.9715315 18.7017099 51.0082244 18.3906534 51.0082095"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E9A32",
    cx: 11.5,
    cy: 36.0360721,
    rx: 7.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6352588,61.5360721 C7.97445245,43.0942141 11.5983316,24.7195182 11.6353488,24.5360721 L11.9999083,24.5879201 C11.9629828,24.7709112 8.34975577,43.0961827 12,61.4851301 L11.6352588,61.5360721 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(14.526823, 35.040859) rotate(-28.141600) translate(-14.526823, -35.040859) ",
    points: "10.5792074 34.8851419 18.4744237 34.8855194 18.4744386 35.1965759 10.5792223 35.1961984"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(7.178785, 36.907040) rotate(-61.842580) translate(-7.178785, -36.907040) ",
    points: "7.02306803 32.9594241 7.3341246 32.959439 7.33450227 40.854655 7.0234457 40.8546401"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E9A32",
    cx: 29.5,
    cy: 27.0360721,
    rx: 10.5,
    ry: 21.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7196076,62.5360721 C26.8699919,37.1160836 30.6807405,11.7889031 30.7196769,11.5360721 L30.9999308,11.588317 C30.9610636,11.8406894 27.1585038,37.1180686 31,62.4847402 L30.7196076,62.5360721 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(34.028718, 25.127469) rotate(-28.141600) translate(-34.028718, -25.127469) ",
    points: "28.6267344 24.9716827 39.4306867 24.9721993 39.4307016 25.2832559 28.6267493 25.2827393"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(23.973502, 27.681176) rotate(-61.843290) translate(-23.973502, -27.681176) ",
    points: "23.8177149 22.279193 24.1287714 22.2792079 24.1292882 33.0831598 23.8182317 33.083145"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    cx: 118,
    cy: 48.5360721,
    rx: 4,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.303464,61.5360721 C118.862796,52.0660301 117.319164,42.630202 117.303389,42.5360721 L117.000075,42.5880776 C117.015773,42.6817511 118.550542,52.0680047 117,61.4849754 L117.303464,61.5360721 Z",
    id: "Path",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#6C63FF",
    transform: "translate(116.065449, 48.035738) rotate(-61.858400) translate(-116.065449, -48.035738) ",
    points: "115.909824 46.0174532 116.22088 46.0174681 116.221073 50.0540218 115.910017 50.0540069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#6C63FF",
    transform: "translate(119.822363, 48.989863) rotate(-28.157960) translate(-119.822363, -48.989863) ",
    points: "117.804009 48.8342384 121.840702 48.8344315 121.840717 49.1454881 117.804024 49.145295"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E9A32",
    cx: 127.5,
    cy: 36.0360721,
    rx: 7.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36474,61.5360721 C130.02555,43.0942141 126.401666,24.7195182 126.36465,24.5360721 L126.00009,24.5879201 C126.037016,24.7709112 129.650246,43.0961827 126,61.4851301 L126.36474,61.5360721 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(123.841623, 35.040856) rotate(-61.858400) translate(-123.841623, -35.040856) ",
    points: "123.685906 31.0932401 123.996963 31.093255 123.997341 38.9884712 123.686284 38.9884564"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(131.189666, 36.907053) rotate(-28.157420) translate(-131.189666, -36.907053) ",
    points: "127.24205 36.7513355 135.137266 36.7517132 135.137281 37.0627697 127.242065 37.0623921"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5E9A32",
    cx: 109.5,
    cy: 27.0360721,
    rx: 10.5,
    ry: 21.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.280392,62.5360721 C112.130009,37.1160836 108.319258,11.7889031 108.280323,11.5360721 L108.000069,11.588317 C108.038936,11.8406894 111.841495,37.1180686 108,62.4847402 L108.280392,62.5360721 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(104.339729, 25.127465) rotate(-61.858400) translate(-104.339729, -25.127465) ",
    points: "104.183942 19.7254817 104.494999 19.7254966 104.495515 30.5294488 104.184459 30.5294339"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(114.394946, 27.681163) rotate(-28.156710) translate(-114.394946, -27.681163) ",
    points: "108.992963 27.5253767 119.796915 27.5258935 119.79693 27.83695 108.992978 27.8364332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7972534,14.6252992 L81,13.5511155 C80.0656398,13.4360056 79.6817292,14.0050291 79.5246091,14.4554166 C78.7946534,14.1169439 78,14.5605269 78,14.5605269 L80.4064744,15.5360721 C80.2850715,15.1739805 80.0737385,14.858042 79.7972534,14.6252992 L79.7972534,14.6252992 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7972534,5.6252992 L51,4.55111546 C50.0656398,4.43600559 49.6817292,5.00502914 49.5246091,5.45541658 C48.7946534,5.11694395 48,5.56052692 48,5.56052692 L50.4064744,6.53607214 C50.2850715,6.17398054 50.0737385,5.858042 49.7972534,5.6252992 L49.7972534,5.6252992 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7972534,1.6252992 L100,0.551115461 C99.0656398,0.436005588 98.6817292,1.00502914 98.5246091,1.45541658 C97.7946534,1.11694395 97,1.56052692 97,1.56052692 L99.4064744,2.53607214 C99.2850715,2.17398054 99.0737385,1.858042 98.7972534,1.6252992 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.178499,59.8027732 C100.858953,59.8027307 100.545046,59.8887193 100.268429,60.0520683 C99.6944742,59.5220924 98.8685103,59.3873811 98.1614297,59.7084255 C97.4543491,60.0294699 96.9990581,60.745925 97,61.5360721 L103,61.5360721 C102.932146,60.559863 102.136959,59.8031808 101.178499,59.8027732 L101.178499,59.8027732 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1784989,59.8027732 C37.8589533,59.8027307 37.5450456,59.8887193 37.2684287,60.0520683 C36.6944742,59.5220924 35.8685103,59.3873811 35.1614297,59.7084255 C34.4543491,60.0294699 33.9990581,60.745925 34,61.5360721 L40,61.5360721 C39.9321462,60.559863 39.1369588,59.8031808 38.1784989,59.8027732 L38.1784989,59.8027732 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1784989,59.8027732 C69.8589533,59.8027307 69.5450456,59.8887193 69.2684287,60.0520683 C68.6944742,59.5220924 67.8685103,59.3873811 67.1614297,59.7084255 C66.4543491,60.0294699 65.9990581,60.745925 66,61.5360721 L72,61.5360721 C71.9321462,60.559863 71.1369588,59.8031808 70.1784989,59.8027732 L70.1784989,59.8027732 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "64 55.5360721 46 55.5360721 46 56.1074498 48.8072385 56.1074498 48.8072385 61.5360721 49.3878312 61.5360721 49.3878312 56.1074498 60.3217368 56.1074498 60.3217368 61.5360721 60.9024651 61.5360721 60.9024651 56.1074498 64 56.1074498"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 46,
    y: 53.5360721,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 46,
    y: 52.5360721,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 46,
    y: 50.5360721,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "92 55.5360721 74 55.5360721 74 56.1074498 76.8072385 56.1074498 76.8072385 61.5360721 77.3878312 61.5360721 77.3878312 56.1074498 88.3217368 56.1074498 88.3217368 61.5360721 88.9024651 61.5360721 88.9024651 56.1074498 92 56.1074498"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 74,
    y: 53.5360721,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 74,
    y: 52.5360721,
    width: 18,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 74,
    y: 50.5360721,
    width: 18,
    height: 1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIllustration);
export default __webpack_public_path__ + "static/media/emptyIllustration.2243d7fab709c5d6332d5cdfc7158575.svg";
export { ForwardRef as ReactComponent };